var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"align-center":"","column":"","justify-center":""}},[_c('v-flex',{staticClass:"spinner",attrs:{"xs2":""}},[_c('div',{staticClass:"half-circle-spinner"},[_c('div',{staticClass:"circle circle-1"}),_c('div',{staticClass:"circle circle-2"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }